// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nu-0";